import { useState } from "react";
import { useTranslation } from "react-i18next";
import SignInFormComponent from "src/components/user/sign-in-form-component";
import SignInSideComponent from "src/components/user/sign-in-side-component";
import SignInToggleComponent from "src/components/user/sign-in-toggle-component";

function SignInContainer() {
  const { i18n, t } = useTranslation();
  const [isParentAccount, setIsParentAccount] = useState<boolean>(false);

  return (
    <div className="flex bg-zinc50 h-screen flex-row justify-center items-center gap-[4%] mx-auto">
      <SignInSideComponent />
      <div
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
        className="flex flex-col w-[425px] mobile:mt-52 tablet:mt-52 mobile:mx-4"
      >
        <p className="font-arMedium text-2xl mobile:text-base">
          {t("app.shared.signin")} 
        </p>
        <SignInToggleComponent
          isParentAccount={isParentAccount}
          setIsParentAccount={setIsParentAccount}
        />
        <SignInFormComponent isParentAccount={isParentAccount} />
      </div>
    </div>
  );
}

export default SignInContainer;
